var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSidebarMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 172,
    viewBox: "0 0 375 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h375v172H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#483EFF"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-151.029 -133.957)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6259FF",
    d: "M79.546 349.634c54.547 128.646 292.524 204.132 354.626 99.852 62.102-104.28-95.035-123.204-150.583-230.963-55.547-107.759-98.711-175.015-178.973-150.466C24.354 92.607 25 220.987 79.546 349.634Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.864,
    cy: 258.711,
    fill: "#FFAF7E",
    rx: 96.329,
    ry: 96.373
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9818E",
    d: "M464.88 433.146c87.31-40.69 133.585-206.525 60.253-246.82-73.333-40.293-82.587 68.465-155.485 109.343-72.898 40.877-118.192 72.245-99.348 126.973 18.845 54.728 107.27 51.194 194.58 10.504Z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m367.336 243.125 15.263-15.549M430.872 251.016l-17.995-15.112M399.36 271.751l-9.94 21.293"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSidebarMobile);
export default __webpack_public_path__ + "static/media/bg-sidebar-mobile.ad41661b40ca0b967f3a9f96479b9c1a.svg";
export { ForwardRef as ReactComponent };